import type { AnalyzeResumeResult } from "@reactive-resume/schema";
import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";

import { axios } from "@/client/libs/axios";

export type ResumeAnalysisResponse = {
  id: string;
  resumeId: string;
  overallScore: number;
  results: AnalyzeResumeResult;
  createdAt: string;
  updatedAt: string;
};

export const findResumeAnalysis = async (data: { id: string }) => {
  try {
    const response = await axios.get<ResumeAnalysisResponse>(`/resume-analysis/${data.id}`);
    return response.data;
  } catch (error: unknown) {
    // Return null if analysis doesn't exist (404)
    if (isAxiosError(error) && error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const useFindResumeAnalysis = (id: string) => {
  return useQuery({
    queryKey: ["resume-analysis", { id }],
    queryFn: () => findResumeAnalysis({ id }),
    enabled: !!id,
  });
};
